export default "__VITE_ASSET__b6ec97da__"